import React, { Suspense,useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import "react-quill/dist/quill.snow.css";
import "./scss/main.scss";
import configureStoreProd from "./Pages/config/configureStore.prod";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import { lazy } from "react";
import PageRoutes from "./PageRoutes";
import Layout from "./components/global/layout/layout";
import socketModel from "./models/socketModel";

const { persistor, store } = configureStoreProd();

function App() {
  // useEffect(() => {
  //   socketModel.emit('connection');
  // }, []);
  const routes = [
    { url: "/login", path: "auth/login",noAuth:true},
    { url: "/dashboard", path: "Dashboard",auth:true},
    { url: "*", path: "NotFoundPage",noAuth:true },
    { url: "/profile", path: "Profile" },
    { url: "/otp", path: "Otp" ,noAuth:true },
    { url: "/profile/:tab", path: "Settings" },
    { url: "/calendar", path: "Shift/FullCalendar" },
    { url: "/shift", path: "Shift" },
    { url: "/shift/edit/:id", path: "Shift/AddEdit" },
    { url: "/shift/add", path: "Shift/AddEdit" },
    { url: "/shift/add/mng", path: "Shift/AddEditmng" },
    { url: "/shift/detail/:id", path: "Shift/View" },
    { url: "/forgotpassword", path: "Forgotpassword",noAuth:true },
    { url: "/resetpassword", path: "Resetpassword",noAuth:true},
    { url: "/staff", path: "Users" },
    { url: "/staff/edit/:id", path: "Users/AddEdit" },
    { url: "/staff/add", path: "Users/AddEdit" },
    { url: "/staff/detail/:id", path: "Users/View" },
    { url: "/dailyreport", path: "DailyReport" },
    { url: "/dailyreport/edit/:id", path: "DailyReport/AddEdit" },
    { url: "/dailyreport/add", path: "DailyReport/AddEdit" },
    { url: "/dailyreport/detail/:id", path: "DailyReport/View" },
    { url: "/attendance", path: "Attendance" },
    { url: "/attendance/edit/:id", path: "Attendance/AddEdit" },
    { url: "/attendance/add", path: "Attendance/AddEdit" },
    { url: "/attendance/detail/:id", path: "Attendance/View" },
    { url: "/budget", path: "Budget" },
    { url: "/budget/edit/:id", path: "Budget/AddEdit" },
    { url: "/budget/add", path: "Budget/AddEdit" },
    { url: "/budget/detail/:id", path: "Budget/View" },
    { url: "/calendar", path: "Booking/Bookingcalendar" },
    { url: "/performance", path: "Performance" },
    { url: "/performance/edit/:id", path: "Performance/AddEdit" },
    { url: "/performance/add", path: "Performance/AddEdit" },
    { url: "/performance/detail/:id", path: "Performance/View" },
    { url: "/", element: <Navigate to="/login" /> },
    { url: "/chats", path: "Chat" },
    { url: "/chats/:id", path: "Chat" },
    { url: "/settings", path: "Settings/ContactDetails" },
  ];
  // promocode
  sessionStorage.clear();
  

  return (
    <>
      <Provider store={store}>
        <PersistGate loading={"loading ..."} persistor={persistor}>
          <Suspense
            fallback={
              <div id="loader" className="loaderDiv">
                <div>
                  <img
                    src="/assets/img/loader.gif"
                    alt="logo"
                    className="loaderlogo"
                  />
                </div>
              </div>
            }
          >
            <Router>
              <Routes>

                {routes.map((itm:any) => {
                  const Element = lazy(() => import(`./Pages/${itm.path}`));
                  const auth=(itm?.auth||!itm?.noAuth)
                  const PageLayout=auth?Layout:itm?.Layout||''

                  return (
                    <Route
                      path={itm.url}
                      element={itm.path ? <PageRoutes url={itm.url} auth={auth} Layout={PageLayout}><Element /></PageRoutes> : itm.element}
                    />
                  );
                })}
              </Routes>
            </Router>
          </Suspense>
        </PersistGate>
      </Provider>
      <div id="loader" className="loaderDiv d-none">
        <div>
          <img src="/assets/img/loader.gif" alt="logo" className="loaderlogo" />
        </div>
      </div>
      <ToastContainer position="top-right" />
    </>
  );
}

export default App;
